import { BsCardText } from 'react-icons/bs';
import PropTypes from 'prop-types';

import { classNames } from '../../../../utils/formatUtils';
import './TotalLineSummary.scss';

const TotalLineSummary = ({ lineInfo, size, className, simpleView }) => (
  <div className={classNames('summary-container', size, className)}>
    {simpleView ? (
      <>
        <div className="modal-card summary-card">
          <p className="modal-card-title">
            <BsCardText className="summary-card-icon" /> Resumen
          </p>
          <p className="summary-card-unit">
            UM: <span className="fw-bold">{lineInfo?.unidadMedida}</span>
          </p>
        </div>
        <div className="modal-card loaded-card">
          <p className="modal-card-title">Cargadas</p>
          <p className="modal-card-quantity">{lineInfo?.cargadas || 0}</p>
        </div>
        <div className="modal-card">
          <p className="modal-card-title">Pendientes</p>
          <p className="modal-card-quantity">{lineInfo?.pendientes || 0}</p>
        </div>
        <div className="modal-card">
          <p className="modal-card-title">Aprobadas</p>
          <p className="modal-card-quantity approved-quantity">{lineInfo?.aprobadas || 0}</p>
        </div>
        <div className="modal-card">
          <p className="modal-card-title">Fijadas</p>
          <p className="modal-card-quantity fixed-quantity">{lineInfo?.fijadas || 0}</p>
        </div>
        <div className="modal-card">
          <p className="modal-card-title">Devueltas</p>
          <p className="modal-card-quantity returned-quantity">{lineInfo?.devueltas || 0}</p>
        </div>
      </>
    ) : (
      <>
        <div className="modal-summary-table-version">
          <div className="modal-card summary-card">
            <p className="modal-card-title">
              <BsCardText className="summary-card-icon" />
              Resumen {className.includes('monthly') ? 'del mes' : ''}
            </p>
          </div>
          {/* <div className="modal-card summary-card">
            <p className="summary-card-unit">
              UM: <span className="fw-bold">{lineInfo?.unidadMedida}</span>
            </p>
          </div> */}
          <div className="modal-card loaded-card loaded-table-view">
            <p className="modal-card-title">Cargadas</p>
            <p className="modal-card-quantity">{lineInfo?.cargadas || 0}</p>
          </div>
        </div>

        <div className="monthly-summary-two-columns">
          {/* Fila/Columna Estado Aprobación */}
          <div className="row-table-version border-between">
            <div className="modal-card">
              <p className="modal-card-title">Estado Aprobación</p>
            </div>
            <div className="modal-card">
              <p className="modal-card-title">Pendientes</p>
              <p className="modal-card-quantity">{lineInfo?.pendientes || 0}</p>
            </div>
            <div className="modal-card">
              <p className="modal-card-title">Devueltas</p>
              <p className="modal-card-quantity returned-quantity">{lineInfo?.devueltas || 0}</p>
            </div>
            <div className="modal-card">
              <p className="modal-card-title">Aprobadas</p>
              <p className="modal-card-quantity approved-quantity">{lineInfo?.aprobadas || 0}</p>
            </div>
            <div className="modal-card">
              <p className="modal-card-title">Fijadas</p>
              <p className="modal-card-quantity fixed-quantity">{lineInfo?.fijadas || 0}</p>
            </div>
          </div>

          {/* Fila/Columna Estado Inspección */}
          <div className="row-table-version">
            <div className="modal-card">
              <p className="modal-card-title">Estado Inspección</p>
            </div>
            <div className="modal-card processing-card">
              <p className="modal-card-title">Procesando</p>
              <p className="modal-card-quantity fixed-quantity">{lineInfo?.procesando || 0}</p>
            </div>
            <div className="modal-card review-card">
              <p className="modal-card-title">En revision</p>
              <p className="modal-card-quantity returned-quantity">{lineInfo?.enRevision || 0}</p>
            </div>
            <div className="modal-card auth-card">
              <p className="modal-card-title">Autorizadas</p>
              <p className="modal-card-quantity approved-quantity">{lineInfo?.autorizadas || 0}</p>
            </div>
            <div className="modal-card rejected-card">
              <p className="modal-card-title">Rechazadas</p>
              <p className="modal-card-quantity">{lineInfo?.rechazadas || 0}</p>
            </div>
          </div>
        </div>
      </>
    )}
  </div>
);

export default TotalLineSummary;

TotalLineSummary.propTypes = {
  lineInfo: PropTypes.shape({
    id: PropTypes.number,
    detalle: PropTypes.string,
    unidadMedida: PropTypes.string,
    cargadas: PropTypes.number,
    pendientes: PropTypes.number,
    aprobadas: PropTypes.number,
    fijadas: PropTypes.number,
    devueltas: PropTypes.number,
    procesando: PropTypes.number,
    enRevision: PropTypes.number,
    autorizadas: PropTypes.number,
    rechazadas: PropTypes.number,
    parteTrabajoDiarios: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        fecha: PropTypes.string,
        cantidad: PropTypes.number,
        um: PropTypes.string,
        estado: PropTypes.string,
        color: PropTypes.string
      })
    )
  }),
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  simpleView: PropTypes.bool
};

TotalLineSummary.defaultProps = {
  lineInfo: null,
  className: '',
  size: 'medium',
  simpleView: false
};
